function toSearchString(params) {
    const query = params.toString();
    return query.length === 0 ? '' : `?${query}`;
}

export default toSearchString;
